import { Label, RadioGroup, RadioGroupItem, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui";
import { BUDGET_YEAR, cn, POSTING_YEAR } from "@/lib/utils";
import { InfoIcon } from "lucide-react";

const Header = ({onOptionChanges, option}:
  {onOptionChanges: (val: any) => void; option: any}) => {
  return (
    <div className="flex flex-row gap-5 items-center">
      <RadioGroup
        onValueChange={onOptionChanges}
        value={option}
        className="flex items-center justify-between gap-3 w-[250px]"
      >
        <div
          className={cn(
            "flex items-center space-x-2",
            option == "1" ? "text-primary" : ""
          )}
        >
          <RadioGroupItem
            value={POSTING_YEAR}
            id="option-one"
            className={option == POSTING_YEAR ? "border-primary" : ""}
          />
          <Label htmlFor="option-one">Posting Year Basis</Label>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger className="mx-1 mt-0" type="button">
                <InfoIcon className="h-5 w-5 stroke-primary" />
              </TooltipTrigger>
              <TooltipContent>
                <div className="flex flex-col text-[14px] text-primary p-3">
                  Posted Date Basis shows actuals when <br/>they occurred. 
                </div>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
        <div
          className={cn(
            "flex items-center space-x-2",
            option == "2" ? "text-primary" : ""
          )}
        >
          <RadioGroupItem
            value={BUDGET_YEAR}
            id="option-two"
            className={option == BUDGET_YEAR ? "border-primary" : ""}
          />
          <Label htmlFor="option-two">Budget Year Basis</Label>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger className="mx-1 mt-0" type="button">
                <InfoIcon className="h-5 w-5 stroke-primary" />
              </TooltipTrigger>
              <TooltipContent>
                <div className="flex flex-col text-[14px] text-primary p-3"> 
                    Budget Year Basis shows actuals aligned to the <br/>
                    budget year they were intended for.
                </div>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
      </RadioGroup>
    </div>
  )
}

export default Header;